export const SKIPBAGS_TYPES = {
  BAGCOLLECTIONSKIPBAGS: "Bag & Collection",
  BAGONLYSKIPBAGS: "Bag Only",
  COLLECTIONONLYSKIPBAGS: "Collection Only",
};
